interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  stroke?: string;
}

/**
 * SVG inline minimalista. Sem libs externas.
 */
export function Sparkline({ values, width = 240, height = 56, stroke = 'var(--color-accent)' }: SparklineProps) {
  if (!values.length) {
    return <div className="h-14 w-full rounded bg-[--color-bg-soft]" aria-label="sem dados" />;
  }
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  const stepX = width / Math.max(1, values.length - 1);
  const points = values
    .map((v, i) => {
      const x = i * stepX;
      const y = height - ((v - min) / range) * height;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
  const areaPoints = `0,${height} ${points} ${width},${height}`;

  return (
    <svg width="100%" height={height} viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none">
      <polygon points={areaPoints} fill={stroke} opacity="0.12" />
      <polyline points={points} fill="none" stroke={stroke} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
